var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNamibia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53268)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.68585 27.3138C5.35704 27.985 6.07316 28.5835 6.82435 29.1105L29.1099 6.8249C28.583 6.07371 27.9844 5.35758 27.3132 4.6864C26.642 4.01521 25.9258 3.41671 25.1747 2.88971L2.88916 25.1753C3.4161 25.9264 4.01466 26.6426 4.68585 27.3138V27.3138Z",
    fill: "#A2001D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6862 4.68623C-0.361554 9.73398 -1.33055 17.3147 1.77713 23.3361L23.336 1.77729C17.3146 -1.3304 9.73382 -0.361273 4.6862 4.68623V4.68623Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3146 27.3137C32.3622 22.2661 33.3312 14.6853 30.2237 8.66382L8.66479 30.2227C14.6861 33.3304 22.2669 32.3614 27.3146 27.3137Z",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.217 9.04357L11.4242 9.88688L12.3789 11.6233L10.4321 11.2509L10.1853 13.2174L8.82934 11.771L7.47328 13.2174L7.22665 11.2509L5.27978 11.6232L6.23446 9.88682L4.44165 9.04357L6.23453 8.20019L5.27978 6.46394L7.22659 6.83632L7.47334 4.86963L8.82934 6.31613L10.1854 4.86963L10.4321 6.83632L12.3789 6.46394L11.4243 8.20025L13.217 9.04357Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53268"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNamibia);
export default __webpack_public_path__ + "static/media/namibia.a76bfaf8.svg";
export { ForwardRef as ReactComponent };